import { createSelector } from '@ngrx/store';
import * as fromPaymentsAndInvoicesReducer from '../reducers';
import * as fromPayrollCalendar from '../reducers/payroll-calendar.reducer';

export const selectPayrollDays = createSelector(
  fromPaymentsAndInvoicesReducer.selectPayrollCalendarEntitiesState,
  fromPayrollCalendar.selectPayrollDays
);
export const selectPayrollDaysIsLoaded = createSelector(
  fromPaymentsAndInvoicesReducer.selectPayrollCalendarEntitiesState,
  fromPayrollCalendar.selectPayrollDaysLoaded
);
export const selectPayrollDaysError = createSelector(
  fromPaymentsAndInvoicesReducer.selectPayrollCalendarEntitiesState,
  fromPayrollCalendar.selectPayrollDaysError
);
